module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.resultados), function(resultado) {
    return _c('v-flex', {
      key: resultado.id,
      attrs: {
        "lg4": ""
      }
    }, [_c('resultado-card', {
      attrs: {
        "resultado": resultado
      }
    })], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5846006c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResultadoPacienteCardList.vue
// module id = 375
// module chunks = 1